export const productColors = [
  { name: 'White', value: '#FFFFFF' },
  { name: 'Black', value: '#000000' },
  { name: 'Navy', value: '#000080' },
  { name: 'Gray', value: '#808080' },
  { name: 'Red', value: '#FF0000' },
  { name: 'Royal Blue', value: '#4169E1' },
  { name: 'Forest Green', value: '#228B22' },
  { name: 'Purple', value: '#800080' },
  { name: 'Maroon', value: '#800000' },
  { name: 'Kelly Green', value: '#4CBB17' }
];